const MaterialLogicMindMapManage = () => import('@/views/main/promotion/materialLogicMindMapManage/MaterialLogicMindMapManage.vue')
export default {
  path: '/main/promotion/materialLogicMindMapManage',
  name: 'MaterialLogicMindMapManage',
  component: MaterialLogicMindMapManage
}
